/* tslint:disable */
/* eslint-disable */
/**
 * Risk Management System API
 * Risk Management System API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ApiFilteredAlertReasonsInner
 */
export interface ApiFilteredAlertReasonsInner {
    /**
     * 
     * @type {string}
     * @memberof ApiFilteredAlertReasonsInner
     */
    reason: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ApiFilteredAlertReasonsInner
     */
    details: Array<string>;
}

/**
 * Check if a given object implements the ApiFilteredAlertReasonsInner interface.
 */
export function instanceOfApiFilteredAlertReasonsInner(value: object): value is ApiFilteredAlertReasonsInner {
    if (!('reason' in value) || value['reason'] === undefined) return false;
    if (!('details' in value) || value['details'] === undefined) return false;
    return true;
}

export function ApiFilteredAlertReasonsInnerFromJSON(json: any): ApiFilteredAlertReasonsInner {
    return ApiFilteredAlertReasonsInnerFromJSONTyped(json, false);
}

export function ApiFilteredAlertReasonsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiFilteredAlertReasonsInner {
    if (json == null) {
        return json;
    }
    return {
        
        'reason': json['reason'],
        'details': json['details'],
    };
}

export function ApiFilteredAlertReasonsInnerToJSON(json: any): ApiFilteredAlertReasonsInner {
    return ApiFilteredAlertReasonsInnerToJSONTyped(json, false);
}

export function ApiFilteredAlertReasonsInnerToJSONTyped(value?: ApiFilteredAlertReasonsInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'reason': value['reason'],
        'details': value['details'],
    };
}

